module.exports = __webpack_public_path__ + "img/fw-l.d36dda83.png";